import { Injectable } from "@angular/core";
import { IuguCreditCard, IuguResponse } from "ngx-iugu";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

declare let Iugu: any;

@Injectable({
    providedIn: "root"
})
export class ApiIuguService {
    constructor() {}

    public init(accountId: string): void {
        Iugu.setAccountID(accountId);
        Iugu.setTestMode(!environment.iugu.production);
    }

    public tokenize(iuguCreditCard: IuguCreditCard): Observable<IuguResponse> {
        return new Observable<IuguResponse>((observable) => {
            const paymentData = Iugu.CreditCard(
                iuguCreditCard.cardNumber,
                iuguCreditCard.cardExpirationMonth,
                iuguCreditCard.cardExpirationYear,
                iuguCreditCard.firstName,
                iuguCreditCard.surName,
                iuguCreditCard.securityCode
            );

            Iugu.createPaymentToken(paymentData, function (response: IuguResponse) {
                if (response.errors) {
                    observable.error(response);
                    return;
                }

                observable.next(response);
                observable.complete();
            });
        });
    }
}
